// Copyright (c) 2015, Orbit7 Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
orbit7._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = orbit7._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = orbit7._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = orbit7._;

orbit7.get_languages = function () {
	if (!orbit7.languages) {
		orbit7.languages = [];
		$.each(orbit7.boot.lang_dict, function (lang, value) {
			orbit7.languages.push({ label: lang, value: value });
		});
		orbit7.languages = orbit7.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return orbit7.languages;
};
